exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card--material__avatar{position:relative;top:-64px;margin-bottom:-32px}.v-card--material__avatar__heading{position:relative;top:-40px;-webkit-transition:.3s ease;transition:.3s ease;z-index:1}.v-card--material__avatar.v-card--material--hover-reveal:hover .v-card--material__heading{-webkit-transform:translateY(-40px);transform:translateY(-40px)}", ""]);

// exports
